const RepaymentType = {
  month: 'hónap',
  year: 'év'
}
export default RepaymentType
